import { forwardRef } from "react"
import { Users, Landmark, Code2, AtSign } from "lucide-react"
import { SearchResult } from "../../../types"

interface Props {
  data: SearchResult
  isActive: boolean
  onClickItem: (item: SearchResult) => void
  onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void
}

const getIcon = (type: string) => {
  switch (type) {
    case "integration":
      return <Code2 size={16} />
    case "subscription":
      return <AtSign size={16} />
    case "loan_officer":
      return <Users size={16} />
    case "brand":
      return <Landmark size={16} />
    default:
      return null
  }
}

const RecentSearchItem = forwardRef<HTMLDivElement, Props>(
  ({ data, isActive, onClickItem, onKeyDown }, ref) => {
    return (
      <div
        ref={ref}
        role="option"
        aria-selected={isActive}
        tabIndex={-1}
        key={data.id}
        className={`search-result flex items-center px-4 text-sm cursor-pointer rounded-md hover:bg-primary-400 hover:text-white transition-colors focus:outline-none ${
          isActive ? "bg-primary-400 text-white" : ""
        }`}
        onClick={() => onClickItem(data)}
        onKeyDown={onKeyDown}
      >
        <div className={isActive ? "text-white" : "text-neutral-400"}>
          {getIcon(data.type)}
        </div>
        <div
          className={`search-result-type p-2 capitalize ${
            isActive ? "text-white" : "text-neutral-400"
          }`}
        >
          {data.type?.split("_").join(" ")}:
        </div>
        <div className="">{data.item}</div>
      </div>
    )
  }
)

RecentSearchItem.displayName = "RecentSearchItem"

export default RecentSearchItem
